// extracted by mini-css-extract-plugin
module.exports = {"label":"FollowedLoadsPerPageSelect_label__jUD3Z","select":"FollowedLoadsPerPageSelect_select__D2EVc"};